import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1855a580"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"
import style0 from "./css/lib.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./App.vue?vue&type=style&index=1&id=1855a580&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports